<base-data-table-header
  [canCreate]="false"
  [canEdit]="false"
  [canImport]="false"
  [canExport]="false"
  [searchWidthFull]="true"
  [loading]="loading"
  [showSelectionActions]="true"
  [selectionCountOnRight]="true"
  [selectedCount]="selectedProducts?.length || 0"
  [totalCount]="count"
  [selectAllDisabled]="(count || 0) === 0"
  [clearSelectionDisabled]="(selectedProducts?.length || 0) === 0"
  (selectAllAcrossPages)="selectAllResults()"
  (clearSelection)="clearAllSelections()"
  (onSearchChange)="onSearchChange($event)"
  (onClearTextFilter)="onClearSearch()"
></base-data-table-header>

<div class="relative">
  <base-data-table
    [dataSource]="dataSource"
    [displayedColumns]="displayedColumns"
    [feisColumns]="feisColumns"
    [showPaginator]="true"
    [stickyTop]="true"
    [canSelectMultiple]="true"
    (onSelectedRow)="selectRow($event)"
    (onPageEvent)="myPageEvent($event)"
    (onSortEvent)="sortEvent($event)"
    [selectedRows]="selected"
    [count]="count"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
  ></base-data-table>

  <!-- Inline overlay to avoid layout jumps -->
  <div *ngIf="loading" class="table-overlay">
    <mat-spinner></mat-spinner>
  </div>
</div>
